import React from "react";

function DoinkCardsVideo() {
  return (
    <section className="doink-cards-video">
      <div className="doink-cards-video-container doink-cards-ad">
        <div className="highlight-video-section highlight-video-section-video">
          <div className="video-wrapper">
            <iframe
              title="butt-slapp"
              width="560"
              height="315"
              src="https://www.youtube.com/embed/tYVd1QG-9bk"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>
        <div className="highlight-video-section">
          <div className="highlight-video-section-info">
            <span className="highlight-video-hint">
              Do you love Disc Golf and laughing at your friends?
            </span>
            <h1>Say Hello To Doink Cards</h1>
            <p>Make your next round of Disc Golf one you won't forget!</p>
          </div>
        </div>
      </div>
    </section>
  );
}

export default DoinkCardsVideo;
